import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TradingPairs from './pages/TradingPairs';
import Triggers from './pages/Triggers';
import Trades from './pages/Trades';
import Exchanges from './pages/Exchanges';
import Settings from './pages/Settings';
import EmergencyStop from './pages/EmergencyStop';

function App() {
  return (
    <Routes>
      {/* Public Route */}
      <Route path="/login" element={<Login />} />

      {/* Protected Routes */}
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/trading-pairs" element={<TradingPairs />} />
                <Route path="/triggers" element={<Triggers />} />
                <Route path="/trades" element={<Trades />} />
                <Route path="/exchanges" element={<Exchanges />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/emergency-stop" element={<EmergencyStop />} />
              </Routes>
            </Layout>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default App;